import React, {useEffect, useState} from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_infostate,
  Option,
  valueToOptionNull,
  valueToOption,
} from "../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_PROFILE_SYSTEM_ADMIN, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {Options} from "./NotifyModel";
import {
  apollo_users_path,
  apollo_info_path,
  info_path,
  infodetail_path,
} from "../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {PageUser} from "../USER/UserModel"
import {ApolloContext} from "../../atom/Apollo_Context";
// メッセージ定義
import {
  GetMessage,
  UI_NOTIFY_EDIT,
} from "../../atom/Apollo_MesasgeDefinition";
// 認証期間切れの処理
import {ApolloExpired} from "../../atom/Apollo_Expired";

import {useHistory, useParams} from "react-router-dom";
import {useForm} from "react-hook-form";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import {FormControlLabel} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

import {ApolloAxios} from "../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import {Info, RelationUser} from "./NotifyModel";
// import makeAnimated from "react-select/animated";
import moment from "moment";
import ApolloNotifyUsers from "../../molecule/NOTIFY/Apollo_NotifyUsers";
// TODO操作ログ
import {ApolloEventRecord, LogData, ItemList} from "../../atom/Apollo_EventRecord";

// const animatedComponents = makeAnimated();

/*
    画面名：通知メッセージ編集画面
 */
const NotifyEdit: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  // 0: 新規　、　id：編集
  const {infoid} = useParams<{infoid: string}>();
  const {data, setmsg} = React.useContext(ApolloMessage);
  const formHooks = useForm<FormData>();
  const {register, handleSubmit, control, formState, errors} = useForm();
  const [info, setInfo] = useState<Info>();
  const [options, setOptions] = useState<Options>({
    option: [],
    selected: [],
  });
  const {state} = React.useContext(ApolloContext);

  const [checked, setChecked] = useState(false);
  // ステータス 1:表示, 2:非表示, 3:下書き
  const [tempStatus, setTempStatus] = useState(3);
  const [users, setUsers] = useState<Option[]>([]);
  // ダブルクリック対応
  const processing = React.useRef(false);
  // 操作前データ
  const beforeData = React.useRef<any>(null);
  const requestData = React.useRef<any>(null);
  const resultData = React.useRef<any>(null);
  const resultApi = React.useRef(-1);
  const logTime = React.useRef("");
  
  useEffect(() => {
    if (infoid === "0") return;
    const url = apollo_info_path + infoid;
    ApolloAxios.get(url).then((response) => {
      const result = response.data.result;
      setInfo(result);
      if (result.sendMail) setChecked(true);
      setTempStatus(result.status);
      // 操作ログ(操作前データ保存)
      beforeData.current = JSON.parse(JSON.stringify(result));
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_EDIT,"E","0"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, []);

  useEffect(() => {
    const url = apollo_users_path;
    ApolloAxios.get(url).then((response) => {
      const users = response.data.result;
      if (users !== undefined) {
        const userOption: Option[] = [];
        const selectedOption: Option[] = [];
        users.map(function (user: PageUser) {
          const row: Option = {
            value: user.userId,
            label: user.familyName + " " + user.firstName,
          }
          userOption.push(row);
        });
        info?.relationUsers.map(function (user: RelationUser) {
          const opt = valueToOptionNull(user.userId, userOption);
          if (opt !== null) {
            selectedOption.push(opt);
          }
        });
        setOptions({
          option: userOption,
          selected: selectedOption,
        })
        setUsers(selectedOption)
      }
    }).catch(err => {
      // 認証期間切れ判定とエラーメッセージ表示
      if (!ApolloExpired(err, GetMessage("0",UI_NOTIFY_EDIT,"E","1"), data, setmsg, history)) {
        // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
      }
    });
  }, [info?.relationUsers]);

  const onSubmit = handleSubmit(async (body: any) => {
    // フォーム送信中なら弾く
    if (formState.isSubmitting) return;
    // processingがtrueなら弾く
    if (processing.current) return;
    // 処理開始時にprocessingをtrueにする
    processing.current = true;
    
    let query = "";
    let method = "作成"
    if (infoid !== "0") {
      query = infoid;
      method = "更新"
    }

    // 配信ユーザーID配列作成
    const userIds: number[] = [];
    if (users) {
      users.map((user) => {
        userIds.push(user.value)
      });
    }

    // 配信ユーザーが未選択の場合はメール送信は不可とする
    if (userIds.length === 0 && checked) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: GetMessage("0",UI_NOTIFY_EDIT,"E","4")
        }
      });
      return;
    }

    let apiBody = {
      infoName: body.infoName,
      infoText: body.infoText,
      status: tempStatus,
      startAt: moment(body.startAt).format(),
      relationUserIds: userIds,
      sendMail: checked ? 1 : 0,
    }

    const url = apollo_info_path + query;

    // 操作日時をセット
    logTime.current = moment().format("YYYY-MM-DD HH:mm:ss");
    // 操作ログ出力(更新)
    resultApi.current = 0;
    // 操作ログ用にリクエストデータ保存
    requestData.current = apiBody;
    // 操作ログ出力
    writeLog();
    
    if (infoid !== "0") {
      // 更新API
      await ApolloAxios.put(url, apiBody).then((response) => {
        // 操作ログ(成功)
        resultApi.current = 1;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: method + GetMessage("0",UI_NOTIFY_EDIT,"I","0")
          }
        });
        history.push(query === "" ? info_path : infodetail_path + infoid);
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, method + GetMessage("0",UI_NOTIFY_EDIT,"E","2"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    } else {
      // 最後のスラッシュを削除する
      const url2 = apollo_info_path.slice(0, -1);
      // 作成API
      await ApolloAxios.post(url2, apiBody).then((response) => {
        // 操作ログ(成功)
        resultApi.current = 1;
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: method + GetMessage("0",UI_NOTIFY_EDIT,"I","1")
          }
        });
        history.push(query === "" ? info_path : infodetail_path + infoid);
      }).catch(err => {
        // 操作ログ(失敗)
        resultApi.current = 9;
        // 認証期間切れ判定とエラーメッセージ表示
        if (!ApolloExpired(err, method + GetMessage("0",UI_NOTIFY_EDIT,"E","3"), data, setmsg, history)) {
          // 認証期間切れ以外のエラーで、エラーメッセージ表示後の処理があれば記述
        }
      }).finally(() => {
        // 操作ログ出力(結果)
        writeLog();
        // 処理終了時にprocessingをfalseにする
        processing.current = false;
      });
    }
  });

  const handelGoback = () => {
    history.push(infoid === "0" ? info_path : infodetail_path + infoid);
  };

  // 送信チェックハンドラ
  const handleChange = (event: any) => {
    if (tempStatus !== 1 && event.target.checked) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "メールを送信する場合は、ステータスは表示を選択してください"
        }
      });
      return;
    }
    setChecked(event.target.checked);
  }

  // ステータス選択ハンドラ
  const handleSelect = (event: any) => {
    if (event.target.value !== 1 && checked) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ステータスを表示以外に変更する場合は、メール送信はできません"
        }
      });
      return;
    }
    setTempStatus(event.target.value);
  }

  // 操作ログ出力
  const writeLog = () => {
    // 操作ログ出力を呼ばれるまでは処理しない
    if (resultApi.current < 0) return;
    var relationUserNames: string[] = [];
    if (infoid !== "0") {
      if (beforeData.current.relationUsers) {
        beforeData.current.relationUsers.forEach((user:any) => {
          relationUserNames.push(user.userName);
        });
      }
    }
    var relationUserNamesResult: string[] = [];
    if (users) {
      users.forEach((user:any) => {
        relationUserNamesResult.push(user.label);
      });
    }
    // 項目リスト
    const itemList: ItemList[] = [
      {
        key: "タイトル",
        beforeValue: infoid === "0" ? "" : beforeData.current?.infoName + "",
        afterValue: requestData.current.infoName + "",
      },
      {
        key: "本文",
        beforeValue: infoid === "0" ? "" : beforeData.current?.infoText + "",
        afterValue: requestData.current.infoText + "",
      },
      {
        key: "配信ユーザー",
        beforeValue: infoid === "0" ? "[]" : "[" + relationUserNames.join("，") + "]",
        afterValue: "[" + relationUserNamesResult.join("，") + "]",
      },
      {
        key: "ステータス",
        beforeValue: infoid === "0" ? "" :  valueToOption(beforeData.current?.status, options_infostate).label + "",
        afterValue: valueToOption(tempStatus, options_infostate).label + "",
      },
      {
        key: "配信開始日時",
        beforeValue: infoid === "0" ? "" : moment(beforeData.current?.startAt).format("YYYY-MM-DD HH:mm:ss") + "",
        afterValue: moment(requestData.current.startAt).format("YYYY-MM-DD HH:mm:ss") + "",
      },
      {
        key: "メールを送信する",
        beforeValue: infoid === "0" ? "" : beforeData.current?.sendMail ? "送信する" : "送信しない",
        afterValue: checked ? "送信する" : "送信しない",
      },
    ];
    // 操作ログ
    const executionLog: LogData = {
      eventDate: logTime.current, // イベント日時 “YYYY-MM-DD HH:mm:ss“ 形式
      logType: resultApi.current === 0 ? "execute" : "result",// ログ種別 実行：execute, 結果：result
      result: resultApi.current === 0 ? "" : resultApi.current === 1 ? "成功" : "失敗",// 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,// ユーザID
      userName: state.userprofile.userName,// Apolloユーザ名 姓 + 半角スペース + ユーザ名
      accessToken: state.accesstoken, // APIアクセス用トークン
      accountGroupID: state.current.accountGroupId, // アカウントグループID
      accountGroupName: state.current.accountGroupId === 0 ? "" : state.current.accountGroupName, // アカウントグループ名
      accountID: state.current.accountId, // 広告主アカウントID
      accountName: state.current.accountGroupId === 0 ? "" : state.current.accountName, // 広告主アカウント名
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "", // メニュー パフォーマンス広告 / メール広告 / ディスプレイ広告
      displayName: "通知メッセージ作成", // 操作画面名称 〇〇画面
      category: "通知メッセージ", // 操作対象 キャンペーン / セグメント etc...
      actionType: infoid === "0" ? "作成" : "更新", // アクション 参照 / 作成 / 更新 / 削除 / アップロード
      targetID: resultApi.current === 0 ? "" : infoid === "0" ? resultData.current ? resultData.current + "" : "" : infoid, // 操作を行うデータのID 実行時は空文字
      targetName: resultApi.current === 0 ? "" : "メッセージ設定ID", // 操作を行うデータの名称 実行時は空文字
      itemList: itemList,
    }
    // 操作ログ出力
    ApolloEventRecord(executionLog);
  };

  return (
    <GenericTemplate title="">

      <ApolloPageUsagePermission role={APOLLO_SYSTEM_ADMIN} profile={APOLLO_PROFILE_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={infoid === "0" ? 36 : 37} zeusaccountid={0} zeuscampaignid={0} adgroupid={0}
                          adid={Number(infoid)} query={""} platform={""}/>

        <form noValidate onSubmit={onSubmit} onKeyDown={e => {
          if (e.key === 'Enter') e.preventDefault();
        }}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="infoName"
                    name="infoName"
                    label="タイトル"
                    key={info?.infoName ? "Loaded" : "Loading"}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 255,
                        message: "255文字以内で入力して下さい。"
                      },
                    })}
                    fullWidth
                    defaultValue={info?.infoName}
                    helperText={errors.infoName && errors.infoName.message}
                    error={errors.infoName ? true : false}
                    autoComplete="タイトル"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="infoText"
                    name="infoText"
                    label="本文"
                    multiline
                    rows={10}
                    key={info?.infoText ? "Loaded" : "Loading"}
                    inputRef={register({
                      required: "必須入力項目です。",
                      maxLength: {
                        value: 65535,
                        message: "65535文字以内で入力して下さい。"
                      },
                    })}
                    fullWidth
                    defaultValue={info?.infoText}
                    helperText={errors.infoText && errors.infoText.message}
                    error={errors.infoText ? true : false}
                    autoComplete="メッセージ"
                  />
                </Grid>
                {/* 配信ユーザー */}
                <Grid item xs={12}>
                  <ApolloNotifyUsers options={options} formHooks={formHooks} setUsers={setUsers} setOptions={setOptions}/>
                </Grid>
                <Grid item xs={12}>
                  {/* <Typography variant="subtitle1" gutterBottom component="div">
                    ステータス
                  </Typography> */}
                  {/* <Controller
                    id="status"
                    name="status"
                    placeholder=""
                    as={Select}
                    key={info?.status ? "Loaded" : "Loading"}
                    control={control}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={
                      info?.status ?
                        valueToOption(info.status, options_infostate)
                        : options_infostate[0]
                    }
                    options={options_infostate}
                    disabled={info?.sendMail ? true : false}
                  /> */}

                  <InputLabel id="status">ステータス</InputLabel>
                  <FormControl error={errors.status ? true : false} fullWidth>
                    <Select
                      labelId="status"
                      id="status"
                      name="status"
                      key={info?.status ? "Loaded" : "Loading"}
                      value={tempStatus}
                      onChange={(e) => handleSelect(e)}
                      disabled={info?.sendMail && tempStatus === 1 ? true : false}
                      required={true}
                    >
                      {
                        options_infostate.map((status: any, index: any) =>
                          <MenuItem value={status.value}>{status.label}</MenuItem>
                        )
                      }
                    </Select>
                    <FormHelperText>{errors.status && errors.status.message}</FormHelperText>
                  </FormControl>

                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="startAt"
                    name="startAt"
                    label="配信開始日時"
                    type="datetime-local"
                    inputRef={register({
                      required: "必須入力項目です。",
                    })}
                    key={info?.startAt ? "Loaded" : "Loading"}
                    defaultValue={info?.startAt ?
                      moment(info?.startAt).format('YYYY-MM-DDTHH:mm')
                      : moment(new Date()).add(1, 'h').format('YYYY-MM-DDTHH:mm')
                    }
                    className={classes.textField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    label="メールを送信する"
                    key={info ? "Loaded" : "Loading"}
                    control={
                      <Checkbox
                        checked={checked}
                        onChange={handleChange}
                        color="primary"
                        disabled={info?.sendMail ? true : processing.current || formState.isSubmitting ? true :false}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <React.Fragment>
                <Button
                  type="submit"
                  color="primary"
                  className={classes.button}
                  onClick={onSubmit}
                  variant="contained"
                  disabled={formState.isSubmitting}
                >
                  {infoid === "0" ? "作成" : "更新"}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handelGoback}
                  className={classes.button}
                >
                  戻る
                </Button>
              </React.Fragment>
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
      <CustomizedSnackbars/>
    </GenericTemplate>
  );
};

export default NotifyEdit;
